import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import { getThemeLocalStorage } from 'helpers/storage';

const {
  REQUEST_AVAILABLE_COUNTRIES,
  REQUEST_AVAILABLE_COUNTRIES_FAILED,
  REQUEST_AVAILABLE_COUNTRIES_SUCCESS,
  REQUEST_LOAD_CONFIG,
  REQUEST_LOAD_CONFIG_FAILED,
  REQUEST_LOAD_CONFIG_SUCCESS,
  REQUEST_GET_CARRIER,
  REQUEST_GET_CARRIER_SUCCESS,
  REQUEST_GET_CARRIER_FAILED,
  REQUEST_GET_TABLE_PRICE,
  REQUEST_GET_TABLE_PRICE_SUCCESS,
  REQUEST_GET_TABLE_PRICE_FAILED,
  REQUEST_ROUTE_LIST,
  REQUEST_ROUTE_LIST_FAILED,
  REQUEST_ROUTE_LIST_SUCCESS,
  CHANGE_THEME,
} = types;

const initialState = {
  isFetchingCountries: true,
  isFetchingConfig: true,
  isFetchingCarrier: true,
  isFetchingPriceTable: false,
  isFetchingRoute: false,
  priceTable: null,
  listRoute: {},
  listConfig: [],
  theme: getThemeLocalStorage(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case CHANGE_THEME: {
      return {
        ...state,
        theme: actions.theme,
      };
    }

    case REQUEST_ROUTE_LIST:
      return {
        ...state,
        isFetchingRoute: true,
      };

    case REQUEST_ROUTE_LIST_SUCCESS:
      return {
        ...state,
        listRoute: actions.data,
        isFetchingRoute: false,
        isFetchedRoute: true,
      };

    case REQUEST_ROUTE_LIST_FAILED:
      return {
        ...state,
        errorRouteList: actions.error,
        isFetchingRoute: false,
      };

    case REQUEST_GET_TABLE_PRICE: {
      return {
        ...state,
        isFetchingPriceTable: true,
      };
    }

    case REQUEST_GET_TABLE_PRICE_SUCCESS: {
      return {
        ...state,
        isFetchingPriceTable: false,
        priceTable: actions.data,
      };
    }

    case REQUEST_GET_TABLE_PRICE_FAILED: {
      return {
        ...state,
        isFetchingPriceTable: false,
        errorPriceTable: actions.error,
      };
    }

    case REQUEST_GET_CARRIER: {
      return {
        ...state,
        isFetchingCarrier: true,
      };
    }

    case REQUEST_GET_CARRIER_SUCCESS: {
      return {
        ...state,
        isFetchingCarrier: false,
        listCarrier: actions.data,
        errorCarrier: null,
      };
    }

    case REQUEST_GET_CARRIER_FAILED: {
      return {
        ...state,
        isFetchingCarrier: false,
        errorCarrier: actions.error,
      };
    }

    case REQUEST_AVAILABLE_COUNTRIES: {
      return {
        ...state,
        isFetchingCountries: true,
      };
    }

    case REQUEST_AVAILABLE_COUNTRIES_FAILED:
      return {
        ...state,
        isFetchingCountries: false,
        errorCountries: actions.error,
      };

    case REQUEST_AVAILABLE_COUNTRIES_SUCCESS:
      return {
        ...state,
        isFetchingCountries: false,
        listCountries: actions.listCountries,
      };

    case REQUEST_LOAD_CONFIG:
      return {
        ...state,
        isFetchingConfig: true,
      };

    case REQUEST_LOAD_CONFIG_SUCCESS:
      return {
        ...state,
        isFetchingConfig: false,
        listConfig: actions.data,
      };

    case REQUEST_LOAD_CONFIG_FAILED:
      return {
        ...state,
        isFetchingConfig: false,
        errorConfig: actions.error,
      };

    default:
      return state;
  }
};
